import { types } from '../constants';

export const parseUrl = (url) => {
  const result = {
    countryType: types.countryType.GREAT_BRITAIN,
    isAdmin: false,
  };

  if (url.includes('adphelper')) {
    result.countryType = types.countryType.SCOTLAND;
  } else if (url.includes('piphelper')) {
    result.countryType = types.countryType.GREAT_BRITAIN;
  }

  if (url.includes('/admin')) {
    result.isAdmin = true;
  }
  return result;
};
